import { getFunctions, httpsCallable } from 'firebase/functions';
import { firebaseApp } from '../infra/firebase/firebaseConfig';
import {
  dev,
  getCachedSessionGrant,
  setCachedSessionGrant,
  type SessionGrant,
} from '@breath-lab/domain';

export { clearSessionTokenCache, type SessionGrant } from '@breath-lab/domain';

export async function fetchSessionToken(
  params: { breathworkId?: string; journeyId?: string },
): Promise<SessionGrant> {
  const cached = getCachedSessionGrant();
  if (cached) return cached;

  dev.log('[session-token] cache miss, fetching from server', params);

  const functions = getFunctions(firebaseApp);
  const requestSession = httpsCallable<
    { breathworkId?: string; journeyId?: string },
    { expiresAt: number }
  >(functions, 'requestBreathworkSession');

  try {
    const result = await requestSession(params);
    dev.log('[session-token] fetch success');
    const grant: SessionGrant = { expiresAt: result.data.expiresAt };
    setCachedSessionGrant(grant);
    return grant;
  } catch (e) {
    dev.error('[session-token] fetch failed', e);
    throw e;
  }
}
